module.exports = __webpack_public_path__ + "img/process-icon1.b81e0d86.png";